module.exports = __webpack_public_path__ + "img/240.3838760e.svg";